<template>
  <div>
    <el-row :gutter="10">
      <el-col :span="4">
        <el-card>
          <h3 style="text-align: center">生产任务</h3>
        </el-card>
        <el-card style="min-height: 648px">
          <el-select v-model="form.parkId" @change="landOptionSearch">
            <el-option
              v-for="(item,index) in areaOption"
              :label="item.name"
              :value="item.id"
              :key="item.id"
            >
            </el-option>
          </el-select>
          <ul class="landList">
            <li v-for="(item,index) in landOption" @click="landChoose(item.id,$event)">{{item.name}}</li>
          </ul>
        </el-card>
<!--        <el-card class="box-card leftMenu" style="height: 540px">-->
<!--          <h3 style="text-align: center;margin-top: -6px;">生产任务</h3>-->
<!--          <el-menu-->
<!--          default-active="2"-->
<!--          class="el-menu-vertical-demo left-menu"-->
<!--          :unique-opened="true"-->
<!--          @open="handleOpen"-->
<!--          @close="handleClose">-->
<!--          <el-submenu-->
<!--            v-for="(item,index) in itemMenuOption"-->
<!--            :index="item.id+''"-->
<!--            :key="index"-->
<!--          >-->
<!--            <span slot="title">{{item.name}}</span>-->
<!--            <el-menu-item-group>-->
<!--              <el-menu-item-->
<!--                v-for="(itemChild,index) in item.children"-->
<!--                :index="itemChild.id+''"-->
<!--                :key="index"-->
<!--                @click="menuChoose(itemChild.id)"-->
<!--              >{{itemChild.name}}</el-menu-item>-->
<!--            </el-menu-item-group>-->
<!--          </el-submenu>-->

<!--        </el-menu>-->
<!--        </el-card>-->
      </el-col>
      <el-col :span="20">
        <div class="checkSearchBox">
          <el-radio-group v-model="checkboxGroup1" @change="chooseRadio">
            <el-radio-button
              v-for="(item,index) in screenOption"
              :label="item.label"
              :key="item.value"
              @click="choose(item)"
            >{{item.label}}</el-radio-button>
          </el-radio-group>
        </div>
        <div style="display: flex;flex-wrap: wrap;margin-left: 2%;height: 450px;overflow-y: auto">
          <div v-for="(item,index) in productionTask" style="width:30%;margin-bottom: 20px;margin-right: 15px" >
            <el-card class="f">
              <div>
                <el-tag>{{item.content}}</el-tag>
                <div style="display: flex;flex-wrap: nowrap;justify-content:space-between;margin:10px 0">
                  <span>名称:名称</span>
                  <span>优先级:高</span>
                </div>
                <div style="margin:10px 0">
                  用量:用量
                </div>
                <div>
                  <el-button
                    v-if="item.status=='0'"
                    type="info"
                    @click="statusChange(item)"
                  >{{item.status | stauusString}}
                  </el-button>
                  <el-button
                    v-if="item.status=='1'"
                    type="primary"
                  >{{item.status | stauusString}}
                  </el-button>
                </div>
              </div>
            </el-card>
          </div>
        </div>
        <div class="block" >
          <el-pagination
            style="text-align: center"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-sizes="[6, 12, 18, 24]"
            :page-size="value"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
  import {parkSearch } from '@/api/park.js'
  import {getAreaData } from '@/api/land.js'
  import { excuteGetdata,excuteStatusUpdate } from '@/api/excute-plant.js'
  export default {
    data() {
      return {
        form:{
          id:"",
          parkId:"",
        },
        landOption:[],
        areaOption:[],
        itemMenuOption:[],
        checkboxGroup1:'',
        value1: true,
        value2: true,
        value3: true,
        value4: true,
        value5: true,
        value6: true,
        activate: null,
        options:{
          value: '60%',
          number:'1',
          time1:'2021-01-22',
          time2:'2021-02-23'
        },
        productionTask:[
          // {
          //   tagname:"农药",
          //   name:"农业除草剂",
          //   priority:"高",
          //   usage:"100L",
          //   status:"任务未开始"
          // }
        ],
        currentPage4:1,
        screenOption:[
          {
            label:"打药",
            value:"打药"
          },
          {
            label:"施肥",
            value:"施肥"
          },
          {
            label:"种植",
            value:"种植"
          },
          {
            label:"浇水",
            value:"浇水"
          },
          {
            label:"采摘",
            value:"采摘"
          },
          {
            label:"所有",
            value:null
          }
        ],
        pageNum:1,
        value:6,
        total:0,
        content:null,
        landId:null
      }
    },
    mounted() {
      this.parksearchData()
      // this.excutePlantData()
    },
    filters:{
      stauusString(value){
        if(value==0){
          return "任务待处理"
        }else if(value==1){
          return "任务已完成"
        }
      }
    },
    methods:{
      cancel(){},
      statusChange(sta) {
        this.$confirm('是否已完成任务', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          console.log("点击了确定")
          console.log(sta)
          if(sta.status=="0"){
            sta.status="1"
            sta.laborPlanId=sta.laborPlanId
            excuteStatusUpdate(sta).then(data=>{
              console.log(data)
              this.$message({
                type: 'success',
                message: '提交成功'
              });
            })
          }
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });


      },
      chooseRadio(value){
        if(value!='所有'){
          this.content=value
        }else {
          this.content=null
        }

        this.excutePlantData()
      },
      excutePlantData() {
        let option={
          pageNum:this.pageNum,
          pageSize:this.value,
          content:this.content,
          landId:this.landId,
        }
        excuteGetdata(option).then(data=>{
          console.log(data)
          this.productionTask=data.data.list
          console.log(this.productionTask)
          this.total=data.data.total
        })
      },
      menuChoose(id) {
        this.landId=id
        this.excutePlantData()
      },
      //地块下拉
      landOptionSearch() {
        getAreaData({
          pageNum:1,
          pageSize:100000000,
          enterpriseId:1,
          parkId:this.form.parkId
        }).then((data)=>{
          this.landOption=data.data.list
        }).then(()=>{
          let liItems=document.querySelector(".landList").children;
          for(let i=0;i<liItems.length;i++){
            liItems[i].style.backgroundColor='#009688'
          }
          liItems[0].style.backgroundColor="#00968866"
          this.landId=this.landOption[0].id
          this.excutePlantData()
        })
      },
      //选中地块事件
      landChoose(id,e){
        let liItems=e.target.parentNode.children
        console.log(id,liItems)
        this.landId=id;
        for(let i=0;i<liItems.length;i++){
          liItems[i].style.backgroundColor='#009688'
        }
        e.target.style.backgroundColor="#00968866"
        this.excutePlantData()
      },
      //地块下拉
      // landOptionSearch(id,obj) {
      //   console.log(id,obj)
      //   let option={
      //     pageNum:1,
      //     pageSize:100000000,
      //     enterpriseId:1,
      //   }
      //   getAreaData({
      //     pageNum:1,
      //     pageSize:100000000,
      //     enterpriseId:1,
      //     parkId:id
      //   }).then((data)=>{
      //     obj.children=data.data.list
      //   })
      //
      // },
      //企业主体下拉时查询园区
      parksearchData() {
        let option={
          pageNum:1,
          pageSize:10000000,
          enterpriseId:1,
          name:null
        }
        parkSearch(option).then(data=>{
          this.areaOption=data.data.list;
        }).then(()=>{
          this.form.parkId=this.areaOption[0].id
          this.landOptionSearch()
        }).then(()=>{
          console.log(this.itemMenuOption)
        })
      },
      handleOpen(key, keyPath) {
        this.excutePlantData()
      },
      handleClose(key, keyPath) {
        let option={
          pageNum:1,
          pageSize:6,
          content:this.content,
          landId:null,
        }
        excuteGetdata(option).then(data=>{
          console.log(data)
          this.productionTask=data.data.list
        })
      },
      task(){
        this.activate = '1-1'
      },
      showactivate(a){
        this.activate = a
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.pageNum=1
        this.value=val
        this.excutePlantData()
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.pageNum=val
        this.excutePlantData()
      }
    }
  }
</script>
<style>
  .weather{
    position: relative;
    width: 100%;
    height: 80px;
  }
  .weather img{
    display: block;
    width: 80%;
    height: 80px;
    margin: 0px auto;
  }
  .left-menu{
    border: none;

  }
  .left-menu li i{
    display: none;
  }
  .left-menu .el-submenu{
    width: 80%;
    margin:25px auto;
    background-color: #639e75;
    text-align: center;
  }
  .left-menu  li.el-submenu:first-of-type{
    margin:0px auto;
  }
  .left-menu .el-submenu span{
    color: #fff;
  }
  .left-menu .el-submenu .el-menu-item-group ul .el-menu-item{
    background-color:#639e75 ;
    width: 80%;
    margin:5px auto;
    min-width: 120px;
    border-radius: 7px;
    color: #fff;
  }
  .left-menu .el-menu-item.is-active {
    background-color: skyblue !important;
  }
  /*.left-menu .el-submenu.is-active{*/
  /*  background-color: black !important;*/
  /*}*/
  .left-menu .el-menu-item{
    width: 80%;
    margin:25px auto;
    background-color: #639e75;
    text-align: center;
    color: #fff;
  }
  .left-menu .el-menu-item:hover{
    background: skyblue !important;
  }
  .left-menu .el-submenu__title:hover {
    background: skyblue !important;
  }
  .checkSearchBox{
    display: flex;
    margin-left: 2%;
    margin-bottom: 20px;
  }
  .leftMenu{
    height: 440px;
    overflow-y: auto;
  }
  li{
    list-style: none;
  }
  .landList{
    padding-left: 0px;
  }
  .landList li{
    width: 100%;
    color:#fff;
    padding: 8px 0px;
    text-align: center;
    background-color: #009688;
    margin: 0 auto;
    width: 80%;
    margin-bottom:25px;
    cursor: pointer;
  }
  .activeBgcolor{
    background-color: #00968866;
  }
  .landList li:hover{
    background-color: #00968866;
  }
  .activeColor{
    background-color: #00968866;
  }
</style>



// WEBPACK FOOTER //
// src/components/product/task/executePlant.vue